import { Box, Grid, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from '../hooks/useForm';

const PREFIX = 'Notes';

const classes = {
  container: `${PREFIX}-container`,
  textArea: `${PREFIX}-textArea`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.container}`]: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0),
    },
    flexDirection: 'column',
  },

  [`& .${classes.textArea}`]: {
    width: '100%',
  },
}));

const Notes = ({ notes }) => {
  const { t } = useTranslation('workOrdersTable');
  const notesInitValue = notes ? notes : '';
  const [{ notesValue }, handleInputChange] = useForm({
    notesValue: notesInitValue,
  });

  return (
    <StyledGrid container className={classes.container}>
      <Grid item>
        <Box>
          <Typography variant="subtitle2">{t('detail.notesLabel')}</Typography>
        </Box>
      </Grid>
      <Grid item>
        <form noValidate autoComplete="off">
          <TextField
            id="outlined-textarea"
            name="notesValue"
            multiline
            minRows={4}
            variant="outlined"
            margin="dense"
            className={classes.textArea}
            value={notesValue}
            onChange={handleInputChange}
            helperText={t('detail.notesHelpText')}
          />
        </form>
      </Grid>
    </StyledGrid>
  );
};

export default Notes;
